<template>
  <v-row>
    <v-dialog v-model="dialogconferim" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline grey lighten-2"
          ><p style="font-size: 35px;">ยืนยันการส่งลูกค้า</p></v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <h3>
                  <v-icon style="margin-right:2%"
                    >mdi-card-account-details</v-icon
                  >ข้อมูลโครงการ
                </h3>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  disabled
                  label="รหัสโครงการ"
                  v-model="form.project_code"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  dense
                  label="ชื่อหน่วยงาน"
                  type="text"
                  disabled
                  v-model="form.institution"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="form.province"
                  item-text="name_th"
                  item-value="id"
                  :items="provinceAll"
                  disabled
                  dense
                  label="จังหวัด"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  name="input-7-4"
                  label="ชื่อโครงการ(เรื่อง)"
                  v-model="form.project_name"
                  disabled
                  dense
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.tor_date_start !== null"
              >
                <v-text-field
                  dense
                  label="วันที่เริ่มประกาศ"
                  type="text"
                  disabled
                  v-model="form.tor_date_start"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="form.tor_date_end !== null">
                <v-text-field
                  dense
                  label="วันที่สิ้นสุดประกาศ"
                  type="text"
                  disabled
                  v-model="form.tor_date_end"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="form.expenditure !== null">
                <v-text-field
                  @input="changeExpenditure()"
                  label="งบประมาณโครงการ"
                  dense
                  type="text"
                  disabled
                  v-model="form.expenditure_co"
                >
                  <span slot="append">บาท</span></v-text-field
                >
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="form.genus_typ_id"
                  item-text="genus_typ_name"
                  item-value="genus_typ_id"
                  disabled
                  dense
                  label="ประเภทการจัดหา"
                  :items="torGenusTyp"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-autocomplete
                  v-model="form.type_of_work_id"
                  disabled
                  item-text="job_type_name"
                  item-value="job_type_id"
                  :items="typeOfWork"
                  hide-details="auto"
                  dense
                  chips
                  small-chips
                  label="ประเภทงาน"
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip close small class="chip--select-multi">
                      {{ data.item.job_type_name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content
                        v-text="data.item.job_type_name"
                      ></v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  class="my-2"
                  label="ราคากลาง"
                  disabled
                  v-model="form.middle_price_co"
                  dense
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.induce_date_start !== null"
              >
                <v-text-field
                  dense
                  label="วันที่เริ่มเชิญชวน"
                  type="text"
                  disabled
                  v-model="form.induce_date_start"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.submission_date !== null"
              >
                <v-text-field
                  dense
                  label="วันที่ยื่นเสนอราคา"
                  type="text"
                  disabled
                  v-model="form.submission_date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="form.same_price !== null">
                <v-text-field
                  dense
                  label="มูลค่าผลงานประเภทเดียวกัน"
                  type="text"
                  disabled
                  v-model="form.same_price_co"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.special_features !== null"
              >
                <v-text-field
                  dense
                  label="คุณสมบัติพิเศษ"
                  type="text"
                  disabled
                  v-model="form.special_features"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="form.secret_price !== null">
                <v-text-field
                  dense
                  label="ราคาซอง"
                  type="text"
                  disabled
                  v-model="form.secret_price_co"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.institution_tall !== null"
              >
                <v-text-field
                  dense
                  label="เบอร์โทรหน่วยงาน"
                  type="text"
                  disabled
                  v-model="form.institution_tall"
                ></v-text-field>
              </v-col>
              <v-col style=" width: 10px;  height: 40px;">
                <a style="" @click="changeDownloadLink()"
                  ><u>เปิดดูข้อมูลเพิ่มเติม</u></a
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="conferimproject()" style="color: #fff">
            <v-icon left light style="color: #fff"
              >mdi-content-save-outline</v-icon
            >
            ยืนยันการส่งลูกค้า
          </v-btn>
          <v-btn color="orange" @click="editdata()" style="color: #fff">
            <v-icon left light style="color: #fff">mdi-border-color</v-icon>
            แก้ไขข้อมูล
          </v-btn>
          <v-btn color="red" @click="cancelScreen()" style="color: #fff">
            <v-icon left light style="color: #fff">mdi-close-octagon</v-icon>
            ปิดหน้าจอ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline grey lighten-2"
          ><p style="font-size: 35px;">แก้ไขข้อมูลโครงการ</p></v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <h3>
                  <v-icon style="margin-right:2%"
                    >mdi-card-account-details</v-icon
                  >ข้อมูลโครงการ
                </h3>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  disabled
                  label="รหัสโครงการ"
                  v-model="form.project_code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-textarea
                  outlined
                  label="ชื่อโครงการ(เรื่อง)"
                  v-model="form.project_name"
                  dense
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-text-field
                  label="ชื่อหน่วยงาน"
                  type="text"
                  dense
                  v-model="form.institution"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-text-field
                  label="งบประมาณโครงการ"
                  type="text"
                  dense
                  v-model="form.expenditure"
                  outlined
                >
                  <span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-autocomplete
                  v-model="form.province"
                  item-text="name_th"
                  item-value="id"
                  outlined
                  dense
                  label="จังหวัด"
                  :items="provinceAll"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-autocomplete
                  v-model="form.genus_typ_id"
                  item-text="genus_typ_name"
                  item-value="genus_typ_id"
                  outlined
                  dense
                  label="ประเภทการจัดหา"
                  :items="torGenusTyp"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-autocomplete
                  v-model="form.type_of_work_id"
                  item-text="job_type_name"
                  item-value="job_type_id"
                  :items="typeOfWork"
                  hide-details="auto"
                  dense
                  chips
                  small-chips
                  label="ประเภทงาน"
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip close small class="chip--select-multi">
                      {{ data.item.job_type_name }}
                    </v-chip>
                  </template>

                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content
                        v-text="data.item.job_type_name"
                      ></v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.latitude !== null"
              >
                <v-text-field
                  label="ตำเเหน่งหน้างานlatitude"
                  type="text"
                  dense
                  v-model="form.latitude"
                  outlined
                  v-if="form.latitude !== null"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.longitude !== null"
              >
                <v-text-field
                  class="my-2"
                  label="ตำเเหน่งหน้างานlongitude"
                  v-model="form.longitude"
                  outlined
                  dense
                  target="#dropdown-example-2"
                  v-if="form.longitude !== null"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.induce_date_start !== null"
              >
                <v-text-field
                  label="วันที่เริ่มเชิญชวน"
                  dense
                  @input="changeInduce()"
                  v-model="form.induce_date_start"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.middle_price !== null"
              >
                <v-text-field
                  class="my-2"
                  label="ราคากลาง"
                  v-model="form.middle_price"
                  outlined
                  dense
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.submission_date !== null"
              >
                <v-text-field
                  class="my-2"
                  label="วันที่ยื่นเสนอราคา"
                  v-model="form.submission_date"
                  outlined
                  @input="changeDate()"
                  dense
                  target="#dropdown-example-2"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.same_price !== null"
              >
                <v-text-field
                  class="my-2"
                  label="มูลค่าผลงานประเภทเดียวกัน"
                  v-model="form.same_price"
                  outlined
                  dense
                  @input="changeSame()"
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.special_features !== null"
              >
                <v-text-field
                  class="my-2"
                  dense
                  label="คุณสมบัติพิเศษ"
                  v-model="form.special_features"
                  outlined
                  target="#dropdown-example-2"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.secret_price !== null"
              >
                <v-text-field
                  class="my-2"
                  dense
                  @input="changeSecret()"
                  label="ราคาซอง"
                  v-model="form.secret_price"
                  outlined
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.institution_tall !== null"
              >
                <v-text-field
                  label="เบอร์โทรหน่วยงาน"
                  dense
                  @input="changeTel()"
                  type="text"
                  v-model="form.institution_tall"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="update()" style="color: #fff">
            <v-icon left light style="color: #fff"
              >mdi-content-save-outline</v-icon
            >
            บันทึกเเละยืนยันการส่งลูกค้า
          </v-btn>

          <v-btn color="red" @click="cancelScreenedit()" style="color: #fff">
            <v-icon left light style="color: #fff">mdi-close-octagon</v-icon>
            ปิดหน้าจอ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-col
      cols="12"
      sm="11"
      md="11"
      style="padding-top: 80px; padding-left: 10%;"
    >
      <v-card>
        <v-card-title>
          <p style="font-size: 35px;">ยืนยันการส่งลูกค้า</p>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหาข้อมูล"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="torProject"
          :search="search"
          style="padding-bottom: 50px;"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="showdata(item)">
              mdi-eye
            </v-icon>
          </template>
          <template v-slot:item.expenditure="{ item }">
            {{
              item.expenditure
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      typeOfWork: [],
      input_file: null,
      dialogconferim: false,
      dialogEdit: false,
      search: "",
      provinceAll: null,
      torGenusTyp: [],
      form: {
        type: "tor",
        genustyp: null,
        institution: null, //ชื่อหน่วยงานรับผิดชอบ
        project_code: null, //รหัสโครงการ
        project_name: null, //ชื่อโครงการ
        genus_typ_id: null,
        tor_date_start: null, //วันที่เริ่มประกาศ
        tor_date_end: null, //วันที่สิ้นสุดประกาศ
        tor_date_project: null, //วันที่ประกาศ-วันที่สิ้นสุดรับฟังคำวิจารณ์
        expenditure: "", //งบประมาณโครงการ_co
        expenditure_co: "",
        province: null, //จังหวัด
        genus_typ: null, //ประเภทการจัดหา
        type_of_work_id: null, //ประเภทงาน
        induce_date_start: "", //วันที่เริ่มเชิญชวน
        secret_price: "", //ราคาซอง
        secret_price_co: "",
        institution_tall: "", //เบอร์หน่วยงาน
        same_price: "", //มูลค่าผลงานประเภทเดียวกัน
        same_price_co: "",
        special_features: "", //คุณสมบัติพิเศษ
        submission_date: "", //วันที่ยื่นเสนอราคา
        middle_price: null, //ราคากลาง
        middle_price_co: null,
        download_link: "",
        created_by: localStorage.getItem("username"), //เพิ่มโดย
        created_by_notify: localStorage.getItem("fullname"),
        confirm_admin: null,
        confirm_by: localStorage.getItem("username"),
      },
      headers: [
        { text: "ประเภทประกาศ", value: "announcement_type" },
        { text: "รหัสโครงการ", value: "project_code" },
        { text: "ชื่อโครงการ", value: "project_name" },
        {
          text: "หน่วยงาน",
          align: "start",
          sortable: false,
          value: "institution",
        },
        { text: "งบประมาณ", value: "expenditure" },
        { text: "จังหวัด", value: "name_th" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      torProject: [],
    };
  },
  mounted() {
    // this.$axios
    //   .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
    //   .then((res) => {
    //     if (!res.data.status) {
    //       alert("เวอรันที่ใช้งานไม่ตรงกับเวอร์ชันปัจจุบัน");
    //       location.reload();
    //     }
    //   });
    if (localStorage.getItem("username") !== null) {
      if (localStorage.getItem("role") !== "Admin") {
        alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");
        this.$router.push("/login");
      }
      //----------
    }
    // this.$axios
    //   .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
    //   .then((res) => {
    //     if (!res.data.status) {
    //       alert("เวอรันที่ใช้งานไม่ตรงกับเวอร์ชันปัจจุบัน");
    //       location.reload();
    //     }
    //   });
    axios.get(this.api + "/conferimall").then((res) => {
      this.torProject = [];
      this.torProject = res.data.response;
    });

    axios.get(this.api + "/all/province").then((res) => {
      this.provinceAll = [];
      this.provinceAll = res.data.response;
    });

    axios.get(this.api + "/get/tor_genus_typ").then((res) => {
      this.torGenusTyp = [];
      this.torGenusTyp = res.data.response;
    });
    axios.get(this.api + "/get/ebiiding_jobtype").then((res) => {
      this.typeOfWork = [];
      this.typeOfWork = res.data.response;
    });
  },

  methods: {
    changeDownloadLink() {
      window.open("" + this.form.download_link, "");
    },
    checkdata() {
      if (this.announcement_type === "tor") {
        if (
          this.form.institution !== null &&
          this.form.project_code !== null &&
          this.form.project_name !== null &&
          this.form.genus_typ_id !== null &&
          this.form.tor_date_start !== null &&
          this.form.tor_date_end !== null &&
          this.form.expenditure !== null &&
          this.form.province !== null &&
          this.form.type_of_work_id !== null &&
          this.form.middle_price !== null
        ) {
          this.conferimproject();
        } else {
          if (
            this.form.institution !== null &&
            this.form.project_code !== null &&
            this.form.project_name !== null &&
            this.form.genus_typ_id !== null &&
            this.form.expenditure !== null &&
            this.form.province !== null &&
            this.form.type_of_work_id !== null &&
            this.form.induce_date_start !== null &&
            this.form.secret_price !== null &&
            this.form.same_price !== null &&
            this.form.special_features !== null &&
            this.form.submission_date !== null &&
            this.form.institution_tall !== null &&
            this.form.middle_price !== null
          ) {
            this.conferimproject();
          }
        }
      }
    },
    cancelScreenedit() {
      this.dialogEdit = false;
    },
    cancelScreen() {
      this.dialogconferim = false;
    },
    diaMsg() {
      //console.log("บันทึกข้อมูลเรียบร้อย");
    },
    update() {
      if (this.announcement_type === "tor") {
        axios.post(this.api + "/update/conferim/tor", this.form).then((res) => {
          if (res.data.status) {
            this.diaMsg(
              "สำเร็จ",
              res.data.response,
              "success",
              "mdi-check-circle"
            );
          } else {
            this.diaMsg("ผิดพลาด", res.data.error, "error", "mdi-check-circle");
          }
        });
        this.conferimproject();
      } else {
        axios
          .post(this.api + "/update/conferim/invite", this.form)
          .then((res) => {
            if (res.data.status) {
              this.diaMsg(
                "สำเร็จ",
                res.data.response,
                "success",
                "mdi-check-circle"
              );
            } else {
              this.diaMsg(
                "ผิดพลาด",
                res.data.error,
                "error",
                "mdi-check-circle"
              );
            }
          });
        this.conferimproject();
      }

      this.dialogEdit = false;


      location.reload();
    },
    conferimproject() {
      this.dialogconferim = false;
      this.form.confirm_admin = 1;

      axios.post(this.api + "/update/confirm_admin", this.form).then((res) => {
       
        if (res.data.status) {
 

          location.reload();
        } else {
          alert("บันทึกข้อมูลไม่เรียบร้อย");
        }
      });
      this.dialog = false;
    },
    showdata(item) {
      this.form.download_link = item.download_link;
      this.dialogconferim = true;
      this.form.project_code = item.project_code;
      this.form.institution = item.institution;
      this.form.project_name = item.project_name;
      this.form.tor_date_start = item.tor_date_start;
      this.form.tor_date_end = item.tor_date_end;
      this.form.expenditure = item.expenditure;
      this.form.expenditure_co = item.expenditure
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.form.province = item.province;
      this.form.genus_typ_id = parseInt(item.genus_typ_id);
      this.form.type_of_work_id = item.type_of_work_id
        .replace(/'/g, "")
        .split(",");
      this.form.middle_price = item.middle_price;
      this.form.middle_price_co = item.middle_price
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.announcement_type = item.announcement_type;
      this.form.induce_date_start = item.induce_date_start;
      this.form.submission_date = item.submission_date;
      this.form.same_price = item.same_price;
      if (item.same_price != null) {
        this.form.same_price_co = item.same_price
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.form.same_price_co = null;
      }
      if (item.secret_price != null) {
        this.form.secret_price_co = item.secret_price
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.form.secret_price = null;
      }

      this.form.special_features = item.special_features;
      this.form.secret_price = item.secret_price;

      this.form.institution_tall = item.institution_tall;

    },
    editdata() {
      this.dialogconferim = false;
      this.dialogEdit = true;
    },
    changeDate() {
      this.form.submission_date = this.form.submission_date
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/ตุลาคม/g, "10")
        .replace(/ธันวาคม/g, "12")
        .replace(/พฤศจิกายน/g, "11")
        .replace(/กันยายน/g, "09")
        .replace(/สิงหาคม/g, "08")
        .replace(/กรกฎาคม/g, "07")
        .replace(/มิถุนายน/g, "06")
        .replace(/พฤษภาคม/g, "05")
        .replace(/เมษายน/g, "04")
        .replace(/มีนาคม/g, "03")
        .replace(/กุมภาพันธ์/g, "02")
        .replace(/มกราคม/g, "01")
        .replace(/ /g, "/")
        .trim();
    },
    changeInduce() {
      this.form.induce_date_start = this.form.induce_date_start
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/ตุลาคม/g, "10")
        .replace(/ธันวาคม/g, "12")
        .replace(/พฤศจิกายน/g, "11")
        .replace(/กันยายน/g, "09")
        .replace(/สิงหาคม/g, "08")
        .replace(/กรกฎาคม/g, "07")
        .replace(/มิถุนายน/g, "06")
        .replace(/พฤษภาคม/g, "05")
        .replace(/เมษายน/g, "04")
        .replace(/มีนาคม/g, "03")
        .replace(/กุมภาพันธ์/g, "02")
        .replace(/มกราคม/g, "01")
        .trim();
    },
    changeSame() {
      this.form.same_price = this.form.same_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeMiddle() {
      this.form.middle_price = this.form.middle_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeSecret() {
      this.form.secret_price = this.form.secret_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeTel() {
      this.form.institution_tall = this.form.institution_tall
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .replace(/-/g, "")
        .trim();
    },
  },
};
</script>
